import React from 'react';

import { CalendarOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

import * as S from './styled';

interface IDateRangeLabel {
  start: Date | string;
  end: Date | string;
  format?: string;
}

const DateRangeLabel = ({ start, end, format }: IDateRangeLabel) => {
  const startFormatted = dayjs(start).format(format || 'DD/MM/YYYY');
  const endFormatted = dayjs(end).format(format || 'DD/MM/YYYY');

  return (
    <>
      <S.Label>Selecione um período:</S.Label>
      <CalendarOutlined style={{ fontSize: 15 }} />
      <S.DateRangeText>{`${startFormatted} - ${endFormatted}`}</S.DateRangeText>
    </>
  );
};

export default DateRangeLabel;
